<script lang="ts">
	import { setCookie } from "@utils/setCookie.js";
	import { tick } from "svelte";
	import { Currency } from "@core/schema/Currency.js";
	import { currencyNameMap } from "@core/schema/names/currencyNameMap.js";
	import { getCurrencySymbol } from "@core/utils/formatPrice.js";
	import { Cart } from "../../cart/Cart.svelte.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import { currencyCookieName } from "../../currencyCookieName.js";
	import { selectedCurrency } from "../../state/selectedCurrency.svelte.js";

	const { tenant } = getGlobalTemplateProps();
</script>

<div class="flex gap-3 size-fit">
	{#each Object.values(Currency) as targetCurrency (targetCurrency)}
		{@const isCurrentCurrency = targetCurrency === selectedCurrency.current}
		<button
			type="button"
			class={[
				"size-16 transition-colors justify-center items-center rounded-full border",
				isCurrentCurrency ? "border-white md:hidden xl:flex" : "border-white/16 hover:border-white flex",
			]}
			title={currencyNameMap[targetCurrency][tenant.locale]}
			onclick={async (): Promise<void> => {
				Cart.saveOrderFields({ payment: { currency: targetCurrency } });
				await tick();
				await setCookie(currencyCookieName, targetCurrency);
				location.reload();
			}}
		>
			<span class="text-white text-sm/4 font-medium">
				{getCurrencySymbol(targetCurrency)}
			</span>
		</button>
	{/each}
</div>
